const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN || 'inviteavenue.com';
const BASE_DOMAINS = [MAIN_DOMAIN, 'lvh.me', 'localhost', 'vercel.app'];

export const getSubdomain = () => {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname.replace(/^www\./, '');

  // Check if it's a base domain or subdomain of one
  for (const base of BASE_DOMAINS) {
    if (hostname === base || hostname === '127.0.0.1') return null;
    if (hostname.endsWith(`.${base}`)) return hostname.replace(`.${base}`, '');
  }

  // Custom domain - use as template ID
  return hostname;
};